import type { BookingTimelineLabelEdge } from '@/views/time-slots/types/booking-timeline'

export const HOUR_WIDTH_PX = 160
export const DAY_START_MINUTE = 0
export const DAY_END_MINUTE = 24 * 60

export const BOOKING_TIMELINE_DATE_QUERY_KEY = 'date'
export const BOOKING_TIMELINE_WAYPOINT_TYPE_QUERY_KEY = 'waypointType'
export const BOOKING_TIMELINE_SHOW_REVOKED_QUERY_KEY = 'showRevoked'

/** One-shot focus from Show on Timeline. Removed once the day has narrowed to the address (and scrolled to the booking). */
export const BOOKING_TIMELINE_FOCUS_ADDRESS_QUERY_KEY = 'focusAddress'
export const BOOKING_TIMELINE_FOCUS_GATE_QUERY_KEY = 'focusGate'
export const BOOKING_TIMELINE_FOCUS_BOOKING_QUERY_KEY = 'focusBooking'

/** Revoked bookings stay hidden unless opted in ("Show valid only" switched off), matching the endpoint's own default. */
export const BOOKING_TIMELINE_SHOW_REVOKED_DEFAULT = false

/** 1 s, so the marker label flips right on the minute. */
export const NOW_REFRESH_MS = 1_000

export const SCROLL_PAGE_RATIO = 0.4

/** The now label's width (~40 px) in track minutes. */
export const NOW_LABEL_WIDTH_MINUTES = 15

/** Today opens this far before the current time (AC9). */
export const OPENING_LEAD_MINUTES = 60

/** A closed band narrower than this shows its reason only in the tooltip. */
export const CLOSED_BAND_LABEL_MIN_PX = 96

/** A gate row fits three bookings (96 px) and grows by one row per further overlapping booking. */
export const BLOCK_ROW_HEIGHT_PX = 32
export const GATE_ROW_MIN_ROWS = 3

export const LABEL_EDGE_CLASSES: Record<BookingTimelineLabelEdge, string> = {
  start: 'ps-1',
  center: '-translate-x-1/2',
  end: '-translate-x-full',
}
